import { DSTreeObject } from '../types';

export const addOidHistory = (
	filteredSimulations: DSTreeObject[],
	origialSimulation: DSTreeObject[],
): DSTreeObject[] => {
	return filteredSimulations.map(simulation => {
		const oidhistory = origialSimulation
			.filter(
				({ oname, oid }) =>
					oname === simulation.oname && oid !== simulation.oid,
			)
			.map(({ oid }) => oid);

		return { ...simulation, oidhistory };
	});
};
